export class ErrorResponse {
    constructor(public message: string, public status = 0) {
    }
}

export class CommonErrorResponse {
    constructor(public message: string, public ok = 'OK') {
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/error.modal/error.response.ts